export function canonicalURL(route) {
  const baseUrl = process.env.REACT_APP_CANONICAL_ORIGIN || 'https://joinpipp.com';
  if (!route) {
    return `${baseUrl}${window.location.pathname}`;
  }
  return `${baseUrl}${route !== '/' ? route : ''}`;
}
